import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import styles from './information.scss'
import information_1 from '../../common/images/information/information-1.jpg'
import i_1 from '../../common/images/information/i-1.jpg'
import yd_information from '../../common/images/information/yd-information.png'
import { Pagination } from 'antd'
import User from '@/modules/user'
import InformSkeleton from './InformSkeleton/index'
import defaultImg from '../../common/images/information/default.jpg'
// import { useNavigate } from 'react-router-dom'

const Information = (props) => {
  // const navigate = useNavigate()
  const user = new User()
  const [isSmall, handleIsSmall] = useState(true)
  const dyClassName = (val)=>{
    return val ? styles['active-one'] : styles['active-ones']
  }
  const title_one = '热点精选'
  const title_two = '政策法规'
  const form = {
    pageSize: 4,
    pageNum: 1,
    articleName: '',
    releaseColumn: '热点精选',
    releaseColumnId: ''
  }
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [current, setCurrent] = useState(1)
  const handleScrollTo = (id) => {
    const portalEle = document.getElementById(id)
    if (portalEle) {
      window.scrollTo({
        top: portalEle.offsetTop + 450
      })
    }
  }
  const componentDidMount = (flag, name)=>{
    setData([])
    handleIsSmall(flag)
    const params = {
      ...form
    }
    params.releaseColumn = name
    user.getArticleList(params)
      .then(res => {
        // 只显示50页
        const total = res.total > form.pageSize * 50 ? form.pageSize * 50 : res.total
        setTotal(total)
        setData(res.result)
      })
      .catch((res) => {
        setData([])
        console.log(res)
      })
  }
  // const cutParticulars = (path) => {
  //   console.log(path, 'path')
  //   window.scrollTo({
  //     top: 0
  //   })
  //   // navigate(path)
  //   window.open('https://www.gerlun.com/#' + path)
  // }
  const getPage = (page) => {
    setCurrent(page)
    form.pageNum = page
    handleScrollTo('informationContnet')
    if (isSmall) {
      componentDidMount(true, title_one)
    } else {
      componentDidMount(false, title_two)
    }
  }
  useEffect(()=>{
    componentDidMount(true, title_one)
  }, [])
  return <section className={styles['information']}>
    <div id='informationContnet' className={styles['information-contnet']}>
      <div className={styles['information-1']}>
        <img src={information_1} className={styles['i-img']} alt='information_1' />
        <img src={yd_information} className={styles['yd_information']} alt='yd_information' />
      </div>
      <div className={styles['page-home-cut']}>
        <div></div>
        <div className={dyClassName(isSmall)} onClick={() => componentDidMount(true, title_one)}><a href='/#' onClick={(e) => e.preventDefault()}>{title_one}</a></div>
        <div className={dyClassName(!isSmall)} onClick={() => componentDidMount(false, title_two)}><a href='/#' onClick={(e) => e.preventDefault()}>{title_two}</a></div>
        <div></div>
      </div>
      <div className={styles['page_home_details']}>
        <img src={defaultImg} alt='' style={{ 'display': 'none' }}/>
        <ul className={styles[isSmall ? 'small' : '']}>
          { data && data.length > 0 ? data.map(item => {
            return <li key={item.id}>
              <div className={styles['page-home-left']}><img src={item.thumbnails === null || item.thumbnails.length === 0 ? i_1 : item.thumbnails[0].url} alt='' /></div>
              <Link to={{ pathname: `/listParticulars/` + item.id }} className={styles['page-home-right']} target='_blank'>
                <h3>{item.articleName}</h3>
                <p className={styles['page-home-yd']}>{item.digest}</p>
                <p>{item.docDate}</p>
              </Link>
            </li>
          }) : <InformSkeleton /> }
        </ul>
      </div>
      <Pagination showSizeChanger={false} pageSize={ form.pageSize } total={ total } style={{ textAlign: 'center' }} current={current} onChange={getPage} />
    </div>
  </section>
}

export default Information
